// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-summary-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  font-size: 1.5rem;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
  padding: 0.4rem 1rem;
  height: 3rem;
}

.chat-summary-status.chat-summary-completed {
  background-color: rgba(121, 245, 131, 0.404);
}

.chat-summary-status.chat-summary-failed {
  background-color: rgba(245, 121, 121, 0.404);
}

.chat-summary-status.chat-summary-in-progress {
  background-color: rgba(237, 245, 121, 0.404);
}`, "",{"version":3,"sources":["webpack://./src/app/chat/chat-info-message/chat-summary-status-label/ChatSummaryStatusLabel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,uGAAuG;EACvG,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":[".chat-summary-status {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.8rem;\r\n  font-size: 1.5rem;\r\n  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n  padding: 0.4rem 1rem;\r\n  height: 3rem;\r\n}\r\n\r\n.chat-summary-status.chat-summary-completed {\r\n  background-color: rgba(121, 245, 131, 0.404);\r\n}\r\n\r\n.chat-summary-status.chat-summary-failed {\r\n  background-color: rgba(245, 121, 121, 0.404);\r\n}\r\n\r\n.chat-summary-status.chat-summary-in-progress {\r\n  background-color: rgba(237, 245, 121, 0.404);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
